/**
 * Seed Accounts - Provision new guide and supervisor accounts
 * Requirements: 7.2, 7.3
 */

const NEW_ACCOUNTS = [
  { name: 'Amina', phone: '+212 621-818092', role: 'guide' },
  { name: 'Amina guide', phone: '+212 717-545259', role: 'guide' },
  { name: 'Khalid', phone: '+212 674-287074', role: 'guide' },
  { name: 'Abdelhadi', phone: '+212 766-696194', role: 'pool_supervisor' },
];

/**
 * Provisions new guide/supervisor accounts via the API.
 * Handles duplicate phone errors gracefully (account already exists).
 *
 * @param {object} apiClient - The API client instance with an addGuide(name, phone, role) method
 * @returns {Promise<Array<{name: string, phone: string, role: string, success: boolean, message: string}>>}
 */
export async function provisionNewAccounts(apiClient) {
  const results = [];

  for (const account of NEW_ACCOUNTS) {
    try {
      const result = await apiClient.addGuide(account.name, account.phone, account.role);

      if (result && result.error) {
        const isDuplicate =
          result.error === 'duplicate' ||
          result.error === 'duplicate_phone' ||
          (typeof result.error === 'string' && result.error.toLowerCase().includes('duplic'));

        results.push({
          ...account,
          success: false,
          message: isDuplicate ? 'Compte déjà existant' : (result.error || 'Erreur inconnue'),
        });
      } else {
        results.push({
          ...account,
          success: true,
          message: 'Compte créé avec succès',
        });
      }
    } catch (err) {
      results.push({
        ...account,
        success: false,
        message: 'Erreur de connexion',
      });
    }
  }

  return results;
}

export { NEW_ACCOUNTS };
